import { defaultDataIdFromObject, InMemoryCache } from '@apollo/client';

/**
 * Browser Apollo cache for Remix. Uses ArchiPro ID + __typename keys and chat
 * field policies for paginated conversation lists.
 */
export function createApolloCache(): InMemoryCache {
    return new InMemoryCache({
        dataIdFromObject(responseObject) {
            // Use __typename and ID as cache key instead of the default id, _id.
            if (
                typeof responseObject === 'object' &&
                responseObject !== null &&
                '__typename' in responseObject
            ) {
                const object = responseObject as Record<string, unknown>;
                if (object.ID != null) {
                    return `${object.__typename}:${object.ID}`;
                }
                if (object.id != null) {
                    return `${object.__typename}:${object.id}`;
                }
            }
            return defaultDataIdFromObject(responseObject);
        },
    });
}
